import { ArrowRight } from 'lucide-react';

import Container from './Container';
import Reveal from '../../../components/Reveal';
import canvasTablet from './../../../assets/images/canvas-tablet.png';

const Sparkle = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M12 0c1.1 7 3.9 9.9 12 12-8.1 2.1-10.9 5-12 12-1.1-7-3.9-9.9-12-12 8.1-2.1 10.9-5 12-12Z" />
  </svg>
);

const Canvas = () => {
  return (
    <section className="relative overflow-hidden py-20 lg:py-24">
      {/* green band */}
      <div className="pointer-events-none absolute inset-x-0 top-1/2 z-0 h-[86%] -translate-y-1/2 overflow-hidden bg-gradient-to-b from-accent/10 via-accent/18 to-accent/10 xl:h-[56%]">
        <div className="glow left-[8%] top-1/2 h-[440px] w-[680px] -translate-y-1/2 bg-accent/16" />
      </div>

      <Container className="relative z-10 grid items-center gap-10 lg:grid-cols-2 xl:grid-cols-[1fr_1.15fr] xl:gap-6">
        {/* text */}
        <div>
          <Reveal>
            <h2 className="font-heading text-[2.1rem] font-bold leading-[1.15] sm:text-[2.7rem] lg:text-[3.1rem]">
              <span className="head-fade">Turn every lesson</span>
              <br />
              <span className="head-fade">into a </span>
              <span className="relative ml-1 inline-block font-script font-bold text-white">
                Canvas
                <Sparkle className="absolute -left-4 -top-2 h-3 w-3 text-white/90" />
                <Sparkle className="absolute -top-4 right-6 h-4 w-4 text-accent" />
                <Sparkle className="absolute -right-3 top-2 h-3.5 w-3.5 text-white/90" />
                <svg
                  viewBox="0 0 120 12"
                  fill="none"
                  className="absolute -bottom-1 left-0 w-full text-accent"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M3 8 Q 35 2 60 6 T 117 5"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
            </h2>
          </Reveal>

          <Reveal delay={120}>
            <p className="mt-6 max-w-md text-[0.98rem] leading-relaxed text-white/60">
              Use the Draw feature to write, sketch, highlight, and explain
              concepts directly inside your notes.
            </p>
          </Reveal>

          <Reveal delay={200}>
            <a
              href="https://app.schoolhack.ai"
              target="_blank"
              rel="noreferrer"
              className="btn-primary mt-8 px-6 py-3 text-[0.9rem]"
            >
              Learn more
              <ArrowRight size={16} />
            </a>
          </Reveal>
        </div>

        {/* tablet image */}
        <Reveal
          delay={160}
          className="relative mx-auto w-full max-w-[620px] xl:-ml-[14%] xl:mr-0 xl:w-[128%] xl:max-w-none"
        >
          <div className="glow left-1/2 top-1/2 h-[420px] w-[440px] -translate-x-1/2 -translate-y-1/2 bg-accent/18" />
          <img
            src={canvasTablet}
            alt="School Hack draw feature on tablet"
            className="relative w-full animate-float-slow object-contain drop-shadow-[0_50px_100px_rgba(0,0,0,0.55)]"
          />
        </Reveal>
      </Container>
    </section>
  );
};

export default Canvas;
